(function(){
    'use strict'

    angular
    .module('app.cupones')
    .controller('cupones.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiCupones = 'api/Cupones';

        let vm = this;

        vm.data = {
            estado: 0,
            eventoId: 0,
            usosMaximo: 1,
            numeroUsos: 0,
            precio: 0
        };

        vm.title = 'Cupones';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.estados = [];
        vm.eventos = [];

        vm.uiData = {
            estaEditando: vm.id != 0,
            fechaCaducidadOpened: false,
            openFechaCaducidad(){
                this.fechaCaducidadOpened = !this.fechaCaducidadOpened;
            }
        };

        var promiseEstados = getComboData(vm.estados, 'api/CuponEstados', null, 'Error al cargar los estados');
        var promiseEventos = getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        get();

        function get(){

            $q.all([promiseEstados, promiseEventos])
            .then(function(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiCupones;
                    var promise = ApiBaseService.getAll([vm.id]);

                    promise
                    .then(function(data){
                        data.fechaCaducidad = moment(data.fechaCaducidad).toDate();
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });
        };

        function getEvento(eventoId){
            return vm.eventos.find((evento) => {
                return evento.id == eventoId;
            });
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.data, 'estado' );
            validateSelectProperty($scope.dataForm, vm.data, 'eventoId' );
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            ApiBaseService.remoteController = apiCupones;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                if(response.data.command.success)
                {
                    logger.success('Registro creado con éxito.');
                    clearData();
                }
                else{
                    logger.error(response.data.command.message);
                }
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            ApiBaseService.remoteController = apiCupones;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                if(response.data.command.success)
                {
                    logger.success('Registro modificado con éxito.');
                    $location.path('/cupones');
                }
                else{
                    logger.error(response.data.command.message);
                }
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                estado: 0,
                eventoId: 0,
                usosMaximo: 1,
                numeroUsos: 0,
                monto: 0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "estado":
                    onEstadoChanged(property);
                    break;
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEstadoChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onEventoIdChanged(property)
        {
            const result = validateSelectProperty($scope.dataForm, vm.data, property );

            if(result)
            {
                const evento = getEvento(vm.data.eventoId);
                if(evento)
                {
                    vm.data.monto = evento.precio;
                    vm.data.fechaCaducidad = moment(evento.fechaInicio).toDate();
                }
            }
            else{
                vm.data.monto = 0;
                    vm.data.fechaCaducidad = null;
            }
        };

    }
})();